<template>
  <div>
    <vs-chip color="success" style="font-size: large;
    font-weight: 700;">
			
      {{ VALUE }}
    </vs-chip>
  </div>
</template>
<script>
export default {
  data() {
    return {
      VALUE: "",
    };
  },
  created() {
    this.VALUE = this.params.value;
  },
};
</script>
